import { Controller} from "stimulus"

export default class extends Controller {
  static targets = ['form', 'region', 'submit', 'contents', 'regionSelection', 'searchString']

  connect() {
    this.inputIdentifier = this.data.get('attribute')
  }

  select(e) {
    e.preventDefault()

    let el = e.currentTarget
    const input = document.createElement('input')
    input.setAttribute('type', 'checkbox')
    input.setAttribute('checked', 'checked')
    if (el.getAttribute('data-region-id') != null) {
      input.setAttribute('value', el.getAttribute('data-region-id'))
      input.setAttribute('name', this.inputIdentifier)
      input.setAttribute('data-region-id', el.getAttribute('data-region-id'))
    } else {
      input.setAttribute('value', el.getAttribute('data-region-request-id'))
      input.setAttribute('name', "order_configuration[region_request_ids][]")
      input.setAttribute('data-region-request-id', el.getAttribute('data-region-request-id'))  
    }
    input.setAttribute('data-region-name', el.getAttribute('data-region-name'))
    input.classList.add('hidden')
    this.formTarget.appendChild(input)

    this.configureSelectedItems()
    this.formTarget.requestSubmit()
  }

  deselect(e) {
    e.preventDefault()

    let el = e.currentTarget
    let regionId = el.getAttribute('data-region-id')
    if (regionId != null) {
      let inputEl = this.formTarget.querySelector(`input[data-region-id="${regionId}"]`)
      inputEl.remove()
    } else {
      let regionRequestId = el.getAttribute('data-region-request-id')
      let inputEl = this.formTarget.querySelector(`input[data-region-request-id="${regionRequestId}"]`)
      inputEl.remove()
    }

    this.configureSelectedItems()
    this.formTarget.requestSubmit()
  }

  focusSearch(e) {
      e.preventDefault()

      this.searchStringTarget.value = ''
      this.searchStringTarget.focus()
  }

  configureSelectedItems() {
    // loop through each grouped target and hide/show or not
    this.regionTargets.forEach(el => {
      // determine if checkbox is present or not
      let regionId = el.getAttribute('data-region-id')
      if (regionId != null) {
        let selected = (this.formTarget.querySelector(`input[data-region-id="${regionId}"]`) != null);
        el.querySelector('.selector').classList.toggle('hidden', selected)
        el.querySelector('.deselector').classList.toggle('hidden', !selected)
      } else {
        let regionRequestId = el.getAttribute('data-region-request-id')
        let selected = (this.formTarget.querySelector(`input[data-region-request-id="${regionRequestId}"]`) != null);
        el.querySelector('.selector').classList.toggle('hidden', selected)
        el.querySelector('.deselector').classList.toggle('hidden', !selected)
      }
      
    })

    this.updateSubmit()
  }

  updateSubmit() {
    let names = []
    this.formTarget.querySelectorAll('input[data-region-id]').forEach(el => {
      names.push(el.getAttribute('data-region-name'))
    })
    this.formTarget.querySelectorAll('input[data-region-request-id]').forEach(el => {
      names.push(el.getAttribute('data-region-name'))
    })
    names = names.sort()

    if (names.length == 0) { // must select at least one region to proceed
      $("#update-progress-location").addClass("disabled")
    } else {
      $("#update-progress-location").removeClass("disabled")
    }
    this.submitTarget.classList.toggle("hidden", names.length == 0)
  }
}
